<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="background-custom min-vh-100 d-flex align-items-center"
    :style="`background-image: url('${imgUrl}');` "
  >
    <b-container class="auth-wrapper-3">
      <b-row
        class="justify-content-center middle"
        align-v="center"
      >
        <b-col
          lg="10"
          class="bg-white px-2 py-3 py-lg-5 background-white"
        >
          <b-row>
            <b-col
                sm="12"
                md="6"
                lg="6"
                class="px-xl-2"
            >
              <b-card-title
                  title-tag="h1"
                  class="font-weight-bolder mb-1 text-black"
              >
                Cambiar contraseña
              </b-card-title>
              <div style="width: 25%">
                <hr class="linea">
              </div>
            </b-col>
            <b-col
                sm="12"
                md="6"
                lg="6"
                class="px-xl-2"
            >
              <!-- form -->
              <validation-observer ref="reset-password-form">
                <b-form
                    class="mt-1 mt-md-0"
                    @submit.prevent="handleSubmitResetPassword"
                    @keydown.enter="handleSubmitResetPassword"
                >
                  <div class="pl-lg-3 pr-lg-3">
                    <b-row>
                      <b-col>
                        <b-form-group label="Nueva contraseña" >
                          <validation-provider
                              #default="{ errors }"
                              name="Password"
                              rules="required"
                          >
                            <b-input-group
                                class="input-group-merge"
                                :class="errors.length > 0 ? 'is-invalid':null"
                            >
                              <b-form-input
                                  id="login-password"
                                  v-model="password"
                                  :state="errors.length > 0 ? false:null"
                                  class="form-control-merge"
                                  :type="passwordFieldType"
                                  name="login-password"
                                  placeholder="············"
                              />
                              <b-input-group-append is-text>
                                <feather-icon
                                    class="cursor-pointer"
                                    :icon="passwordToggleIcon"
                                    @click="togglePasswordVisibility"
                                />
                              </b-input-group-append>
                            </b-input-group>
                            <small ref="errorField" class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group label="Repita la contraseña" >
                          <validation-provider
                              #default="{ errors }"
                              name="Repita la contraseña"
                              rules="required"
                          >
                            <b-input-group
                                class="input-group-merge"
                                :class="errors.length > 0 ? 'is-invalid':null"
                            >
                              <b-form-input
                                  id="login-confirmPassword"
                                  v-model="confirmPassword"
                                  :state="errors.length > 0 ? false:null"
                                  class="form-control-merge"
                                  :type="passwordFieldType"
                                  name="login-password"
                                  placeholder="············"
                              />
                              <b-input-group-append is-text>
                                <feather-icon
                                    class="cursor-pointer"
                                    :icon="passwordToggleIcon"
                                    @click="togglePasswordVisibility"
                                />
                              </b-input-group-append>
                            </b-input-group>
                            <small ref="errorField" class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-3">
                      <b-col>
                        <b-button
                            type="submit"
                            variant="primary"
                            class="mt-2 mr-1 text-uppercase"
                        >
                          Enviar
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </b-form>
              </validation-observer>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import {
  BContainer, BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import backgroundImage from '@/assets/images/pages/shireo-login.jpg'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BContainer,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      token: this.$route.params.token,
      email: this.$route.params.email,
      password: '',
      confirmPassword: '',
      imgUrl: backgroundImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    ...mapActions({
      resetPassword: 'auth/resetPassword',
    }),
    async handleSubmitResetPassword() {
      const valid = await this.$refs['reset-password-form'].validate()
      if (!valid) {
        this.$refs.errorField.scrollIntoView({
          behavior: 'smooth',
        block: 'end',
        });
        return
      }

      this.resetPassword({
        email: this.email,
        password: this.password,
        password_confirmation: this.confirmPassword,
        token: this.token,
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
